import React, { useEffect, useState } from 'react';
import { ratings } from '../utils/utils';
import { database } from '../constants/firebase';
import { onValue, ref } from 'firebase/database';

const ReportUserBottomSheet = ({ user, currentUser, onSubmit, onClose }) => {
    const [selectedRating, setSelectedRating] = useState(null);
    const [reason, setReason] = useState('');
    const [isClosing, setIsClosing] = useState(false);
    const [alreadyReported, setAlreadyReported] = useState(false);


    // ✅ Check if current user has already reported this user
    useEffect(() => {
        if (!currentUser || !user) return;
        const reportRef = ref(database, `Users/${currentUser.uid}/reportedUsers/${user.uid}`);
        const unsubscribe = onValue(reportRef, (snapshot) => {
            setAlreadyReported(snapshot.exists());
        });
        return () => unsubscribe();
    }, [currentUser, user]);

    const handleSubmit = () => {
        if (alreadyReported) return;

        if (!selectedRating) {
            alert("Please select a rating.");
            return;
        }
        setIsClosing(true);
        setTimeout(() => {
            onSubmit({ rating: selectedRating, reason });
            onClose();
        }, 300);
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end z-50"
            onClick={handleClose}
        >
            <div
                className={`bg-white dark:bg-[#1E1E1E] w-full max-w-2xl rounded-t-3xl p-6 text-center 
                ${isClosing ? 'animate-slide-down' : 'animate-slide-up'}`}
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-2xl font-bold text-black dark:text-white">Report bad content</h2>
                <p className="text-gray-600 dark:text-gray-400 mt-2">
                    Rate the content of the message for review:
                </p>

                <div className="flex justify-center items-end space-x-4 md:space-x-6 my-6">
                    {ratings.map((rating) => (
                        <div
                            key={rating.name}
                            className={`flex flex-col items-center ${alreadyReported ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                                }`}
                            onClick={() => !alreadyReported && setSelectedRating(rating.name)}
                        >
                            <span
                                className={`text-4xl md:text-5xl transition-transform duration-200 
                                ${selectedRating === rating.name ? 'scale-125' : 'scale-100'}`}
                                style={{
                                    filter:
                                        selectedRating && selectedRating !== rating.name
                                            ? 'grayscale(80%)'
                                            : 'none',
                                    opacity:
                                        selectedRating && selectedRating !== rating.name ? 0.6 : 1,
                                }}
                            >
                                {rating.emoji}
                            </span>
                            <span className="text-xs text-gray-700 dark:text-gray-300 mt-2">
                                {rating.name}
                            </span>
                        </div>
                    ))}
                </div>

                {!alreadyReported && (
                    <>
                        <h3 className="text-lg font-semibold text-black dark:text-white mt-8">
                            Why did you rate it this way?
                        </h3>
                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Type your answer here..."
                            className="w-full h-28 mt-4 p-3 rounded-lg border border-gray-300 dark:border-gray-600 
                            bg-gray-50 dark:bg-[#2A2A2A] text-black dark:text-white 
                            focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </>
                )}

                <button
                    onClick={handleSubmit}
                    disabled={alreadyReported}
                    className={`w-full font-bold py-4 rounded-full mt-6 transition 
                        ${alreadyReported
                            ? "bg-gray-400 text-white opacity-60 cursor-not-allowed"
                            : "bg-primary text-white"
                        }`}
                >
                    {alreadyReported ? "Reported" : "Submit"}
                </button>
            </div>
        </div>
    );
};

export default ReportUserBottomSheet;
